import { DEFAULT_ICONS_PATH } from '@taiga-ui/core';

const EDITOR_ICONS_MAPPER: Record<string, string> = {
  backgroundLarge: 'editor/background-large',
  layersLarge: 'editor/layers-large',
  triangle: 'editor/triangle',
  rectangle: 'editor/rectangle',
  ellipse: 'editor/ellipse',
  line: 'editor/line',
  background: 'editor/background',
  layers: 'editor/layers',
  image: 'editor/image',
  productImage: 'editor/product-image',
  productImageLabel: 'editor/product-image-label',
  productRegion: 'editor/product-region',
  productCity: 'editor/product-city',
  productCountry: 'editor/product-country',
  textField: 'editor/text-field',
  priceField: 'editor/price-field',
  percentField: 'editor/percent-field',
  text: 'editor/text',
  productTitle: 'editor/product-title',
  productBrand: 'editor/product-brand',
  productType: 'editor/product-type',
  price: 'editor/price',
  salePrice: 'editor/sale-price',
  actualPrice: 'editor/actual-price',
  saleValue: 'editor/sale-value',
  salePercent: 'editor/sale-percent',
  additionalImage: 'editor/additional-image',
  customLabel: 'editor/custom-label',
  customLabel0: 'editor/custom-label-0',
  customLabel1: 'editor/custom-label-1',
  customLabel2: 'editor/custom-label-2',
  customLabel3: 'editor/custom-label-3',
  customLabel4: 'editor/custom-label-4',
  customNumber: 'editor/custom-number',
  customNumber0: 'editor/custom-number-0',
  customNumber1: 'editor/custom-number-1',
  customNumber2: 'editor/custom-number-2',
  customNumber3: 'editor/custom-number-3',
  customNumber4: 'editor/custom-number-4',
  figma: 'editor/figma',
  psd: 'editor/psd',
  beta: 'editor/beta',
  crossOutDirectionCenter: 'editor/cross-out-direction-center',
  crossOutDirectionDown: 'editor/cross-out-direction-down',
  crossOutDirectionUp: 'editor/cross-out-direction-up',
  betaFull: 'editor/beta-full',
  undo: 'editor/undo',
  redo: 'editor/redo',
  badge: 'editor/badge',
  polygon: 'editor/polygon',
  temperature: 'editor/temperature',
  weather: 'editor/weather',
  star: 'editor/star',
  alignTop: 'editor/align-top',
  alignBottom: 'editor/align-bottom',
  alignLeft: 'editor/align-left',
  alignRight: 'editor/align-right',
  alignVerticalCenters: 'editor/align-vertical-centers',
  alignHorizontalCenters: 'editor/align-horizontal-centers',
  productField: 'editor/product-field'
};

const ICONS_MAPPER: Record<string, string> = {
  aitarget: 'aitarget',
  darkTheme: 'dark-theme',
  lightTheme: 'light-theme',
  logout: 'logout',
  template: 'template',
  bag: 'bag',
  grid: 'grid',
  folder: 'folder',
  video: 'video',
  images: 'images',
  note: 'note',
  equal: 'equal',
  videoResult: 'video-result',
  playingBars: 'playing-bars',
  noteAlt: 'note-alt',
  play: 'play',
  playSpecial: 'play-special',
  pause: 'pause',
  playLarge: 'play-large',
  pauseLarge: 'pause-large',
  verticalFit: 'vertical-fit',
  horizontalFit: 'horizontal-fit',
  bothFit: 'both-fit',
  drag: 'drag',
  clock: 'clock',
  arrowCenter: 'arrow-center',
  arrowDownLeft: 'arrow-down-left',
  arrowDownRight: 'arrow-down-right',
  arrowDown: 'arrow-down',
  arrowLeft: 'arrow-left',
  arrowRight: 'arrow-right',
  arrowRightThin: 'arrow-right-thin',
  arrowUpLeft: 'arrow-up-left',
  arrowUpRight: 'arrow-up-right',
  arrowUp: 'arrow-up',
  videoPlayerPreview: 'video-player-preview',
  plusExtraLarge: 'plus-extra-large',
  trash: 'trash',
  settings: 'settings',
  sliders: 'sliders',
  copy: 'copy',
  upload: 'upload',
  download: 'download',
  refresh: 'refresh',
  edit: 'edit',
  star: 'star',
  scaleToFull: 'scale-to-full',
  lock: 'lock',
  cutFit: 'cut-fit',
  cutCenter: 'cut-center',
  fitEllipse: 'fit-ellipse',
  fillCut: 'fill-cut',
  textLeft: 'text-align/text-left',
  textCenter: 'text-align/text-center',
  textRight: 'text-align/text-right',
  flipHorizontal: 'add-image-modal/flip-horizontal',
  flipVertical: 'add-image-modal/flip-vertical',
  rotateLeft: 'add-image-modal/rotate-left',
  rotateRight: 'add-image-modal/rotate-right',
  usa: 'locale/usa',
  rus: 'locale/rus',
  eng: 'locale/eng',
  chat: 'chat',
  unknown: 'unknown',
  eyedropper: 'eyedropper',
  eyedropperCursor: 'eyedropper-cursor',
  dashedPlus: 'dashed-plus',
  globe: 'globe',
  globeLarge: 'globe-large',
  tag: 'tag',
  tagLarge: 'tag-large',
  google: 'google',
  tiktok: 'tiktok',
  kpi: 'kpi',
  ...EDITOR_ICONS_MAPPER
};

export function iconsPath(name: string): string {
  if (ICONS_MAPPER[name]) {
    return `assets/icons/${ICONS_MAPPER[name]}.svg#${ICONS_MAPPER[name]}`;
  } else if (name.startsWith('tuiIcon')) {
    return `assets/taiga-ui/icons/${name}.svg#${name}`;
  } else {
    return DEFAULT_ICONS_PATH(name);
  }
}
